import { ca } from '@cian/analytics';

/**
 * Клик на кнопку Заметка
 */
export function trackNoteButtonClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'add_comment',
  });
}
